<div
  class="auto-complete-dropdown-container"
  [ngClass]="{ showing_suggestions: showSuggestions }"
>

  <div class="search-bar" [ngClass]="{ search_focused: focusSearch }" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <input
      #searchInput
      autocomplete="off"
      type="search"
      name="search"
      [id]="id"
      [readOnly]="readonly"
      [placeholder]="placeholder"
      [(ngModel)]="searchTerm"
      (ngModelChange)="updateSearchTerm()"
      (focus)="onInputFocus()"
      (focusout)="onInputFocusOut()"
      (keyup.escape)="showSuggestions = false"
      [disabled]="disable"
      [ngClass]="{'form_error': hasError(), 'show-icon': showIcon}"
      (keydown)="onInputKeydown($event)"
      (paste)="onInputPaste($event)"
      (input)="handleInput()"
    />
    <app-svg-icon class="image-icon" [path]="'assets/icons/search_icon.svg'" *ngIf="showIcon"></app-svg-icon>
    <div class="role_chips" *ngIf="multiSelect && selectedItems.size > 0">
      <div class="chip">
        <span>{{ selectedItems.size }} Item(s)</span>
        <span class="remove-chip" (click)="removeAllSelections()">&times;</span>
      </div>
    </div>
  </div>
  <ng-template
    cdk-connected-overlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="showSuggestions"
    [cdkConnectedOverlayPanelClass]="'autocomplete-overlay-panel'"
    [cdkConnectedOverlayWidth]="triggerWidth"
    [cdkConnectedOverlayHasBackdrop]="true"
    (overlayOutsideClick)="showSuggestions = false"
    [cdkConnectedOverlayPositions]="overlayPositions"
  >
    <div
      class="search-results"
      [ngClass]="{ search_focused: focusSearch }"
      (scroll)="onScroll($event)"
    >
      <table class="suggestions-table">
        <thead *ngIf="displayColumns.length > 1 && suggestions.length > 0">
        <tr>
          @if (multiSelect) {
            <th></th>
          }
          <th *ngFor="let column of displayColumns">{{ column.header }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let result of suggestions; let i = index"
            (click)="select(result)"
            (keyup.enter)="select(result)"
            (mouseenter)="setActiveOption(i)"
            #optionRow
            [class.active]="i === activeOptionIndex">
          <td *ngIf="multiSelect" class="cb_td"><input type="checkbox" [checked]="result.selected"></td>
          <td *ngFor="let column of displayColumns">
             <span [innerHTML]="CommonUtils.getNestedValue(result, column.key)"></span>
          </td>
        </tr>
        <tr
          *ngIf="suggestions.length === 0 && allowCustomInput && searchTerm"
          (click)="selectCustomInput(); $event.stopPropagation()"
        >
          <td [attr.colspan]="displayColumns.length" class="custom-input-suggestion">
            Use "<strong>{{ searchTerm }}</strong>" as input
          </td>
        </tr>
        </tbody>
      </table>

      <div class="result loading_results" *ngIf="loading">
        <app-spinner-loader></app-spinner-loader>
      </div>

      <div class="result no_results" *ngIf="suggestions.length === 0 && !loading && !allowCustomInput">
          <nz-empty></nz-empty>
      </div>
    </div>
  </ng-template>

</div>
